// extracted by mini-css-extract-plugin
export default {"container":"AboveHeader__container--2Gp"};